import { Component, h, Prop, Host, Element, Listen } from '@stencil/core'

@Component({
    tag: 'c-menu',
    styles: 'c-menu.scss',
})
export class CMenu {
    @Element() el: HTMLElement
    @Prop({ mutable: true }) isOpen: boolean = false

    @Listen('keydown')
    handleKeyDown(event: KeyboardEvent) {
        if (event.key === 'Escape' && this.isOpen) {
            this.isOpen = false;
            (this.el.querySelector('#menu-toggle') as HTMLElement).focus()
        }
    }

    @Listen('click', { target: 'window' })
    handleMouseClick(event: MouseEvent) {
        const target = event.target as HTMLElement
        if (this.isOpen && !this.el.contains(target)) {
            this.isOpen = false;
        }
    }

    render() {
        return (
            <Host class={this.isOpen ? 'menu-active' : ''}>
                <button
                    id="menu-toggle"
                    class="menu-bot"
                    title="Chatbot Menü"
                    aria-label="Chatbot Menü"
                    aria-expanded={this.isOpen ? 'true' : 'false'}
                    data-analytics-track="true"
                    data-analytics-action="ButtonClicks TCB: Klick"
                    data-analytics-value="Menu open"
                    data-analytics-name="TCB: Header Button"
                    data-analytics-category="TCB | ButtonClicks"
                    onClick={(event) => {
                        event.stopPropagation()
                        this.isOpen = !this.isOpen
                        if (!this.isOpen) return
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" enable-background="new 0 0 32 32" fill="#ffffff">
                        <path d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z" />
                    </svg>
                </button>
                {this.isOpen && (
                    <div class="menu-container" tabindex="-1">
                        <c-menu-item mType="Entry" name="Intranetseite" url="https://arbeitsagentur.de/" isOpen={this.isOpen}/>
                        <br />
                        <c-menu-item mType="Entry" name="FAQ (PDF)" url="https://arbeitsagentur.de/" isOpen={this.isOpen}/>
                        <br />
                        <c-menu-item mType="Entry" name="Blog für Aktuelles" url="https://arbeitsagentur.de/" isOpen={this.isOpen}/>
                        <br />
                        <c-menu-item mType="Version" name="Version" />
                    </div>
                )}
            </Host>
        )
    }
}
